import { getConfiguration } from '../../utils/config'
import ChangesReportExport from '../ChangesReportExport/ChangesReportExport'
import Dump from '../Dump/Dump'

import Eval from './Eval/Eval'

import styles from './admin.module.scss'

function Admin() {
    const { adminEvalEnabled } = getConfiguration()
    return (
        <main className={styles.admin}>
            {adminEvalEnabled ? <Eval /> : null}
            <Dump />
            <ChangesReportExport />
        </main>
    )
}

export default Admin
